import React from "react";
import { useApp } from "@/contexts/AppContext";

const tickerItems = [
  "Same-Day Quotes",
  "100% Original Stock",
  "Air & Sea Freight",
  { text: "Blackview Authorized Distributor", strong: true },
  "B2B Wholesale Only",
  "Global Distribution",
];

const tickerItemsAR = [
  "عروض أسعار في نفس اليوم",
  "مخزون أصلي 100٪",
  "شحن جوي وبحري",
  { text: "موزع Blackview المعتمد", strong: true },
  "بيع بالجملة B2B فقط",
  "توزيع عالمي",
];

export const TopSalesBar = () => {
  const { lang } = useApp();
  const items = lang === "ar" ? tickerItemsAR : tickerItems;
  // duplicate for seamless loop
  const marquee = [...items, ...items, ...items];

  return (
    <div
      className="w-full bg-[#0B132B] text-white text-xs border-b border-white/5"
      data-testid="top-sales-bar"
    >
      {/* Row 1 — status */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 min-w-0">
          <span className="inline-flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-70" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
            </span>
            <span className="font-medium">
              {lang === "ar" ? "فريق المبيعات متاح" : "Sales Team Online"}
            </span>
          </span>
          <span className="hidden sm:inline text-slate-400">
            {lang === "ar" ? "استجابة سريعة للمبيعات" : "Fast Sales Response"}
          </span>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <span className="inline-flex items-center gap-1.5 font-semibold tracking-[0.2em] text-[10px]">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-500 opacity-70" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-rose-500" />
            </span>
            LIVE
          </span>
          <span className="hidden sm:inline text-slate-400">Dubai · GST</span>
        </div>
      </div>

      {/* Row 2 — ticker */}
      <div className="relative overflow-hidden bg-[#101833] border-t border-white/5" data-testid="sales-ticker">
        <div className="ticker-track py-1.5 whitespace-nowrap flex gap-10">
          {marquee.map((it, i) => {
            const strong = typeof it === "object" && it.strong;
            const text = typeof it === "string" ? it : it.text;
            return (
              <span
                key={i}
                className={`inline-flex items-center gap-10 ${
                  strong
                    ? "text-[#4785FF] font-semibold tracking-[0.15em] uppercase text-[11px]"
                    : "text-slate-300 tracking-[0.05em] text-[11px]"
                }`}
              >
                {text}
                <span className="text-slate-600">•</span>
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};
